import $ from "jquery";
import { LocalStorage } from "storage-manager-js";
import { localStorage } from "./__constant";

const customRequest = () => {
  const init = () => {
    toggleHeaderDrawer();
  };

  const toggleHeaderDrawer = () => {
    const el = {
      target: ".js-toggle-for-custom",
      trigger: ".js-toggle-class-slide",
      customizerSection: ".js-CustomizerSection",
    };

    const manageViewComponent = (cb) => {
      $(el.target).each(function () {
        const showIf = $(this).data("show_if");
        cb(showIf, $(this));
      });
    };

    $(window).on("load", function () {
      manageViewComponent((showIf, thisEl) => {
        const isHideOnLoad = showIf !== "custom_hide";

        if (isHideOnLoad) {
          thisEl.hide();
        }
      });

      const customizerData = JSON.parse(
        LocalStorage.get(localStorage.customizer)
      );

      const dataIsCustom = [];
      for (const key in customizerData) {
        if (customizerData[key]["request-description"]) {
          dataIsCustom.push(`#request-form-${key.split("-")[1]}`);
        }
      }
      $(document).on("click", el.trigger, function () {
        const initial = $(this).data("for");
        const dataCustomIndex = dataIsCustom.findIndex((v) => v === initial);
        const dataCustomIsExist = dataCustomIndex > -1;

        if (dataCustomIsExist) {
          dataIsCustom.splice(dataCustomIndex, 1);
        } else {
          dataIsCustom.push(initial);
        }

        if (dataIsCustom.length > 1) return;

        manageViewComponent((showIf, thisEL) => {
          const isNotCustomEl = showIf === "custom_hide";
          const isCustomEl = showIf === "custom_show";
          const isCustomShow = dataIsCustom.length > 0;

          if (isCustomShow) {
            if (isNotCustomEl) {
              thisEL.slideUp(300);
              $(el.customizerSection).addClass("CustomizerSection--FullHeight");
            } else {
              thisEL.slideDown(300);
            }
          } else {
            if (isCustomEl) {
              thisEL.slideUp(300);
              $(el.customizerSection).removeClass(
                "CustomizerSection--FullHeight"
              );
              $(initial).find("textarea").val("");
            } else {
              thisEL.slideDown(300);
            }
          }
        });
      });
    });
  };

  init();
};

try {
  customRequest();
} catch (error) {
  console.error("customRequest", error);
}
